import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cases-import',
  templateUrl: '../views/cases-import.component.html',
  styleUrls: ['../css/cases-import.component.css']
})
export class CasesImportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/cases/components/cases-import.component.ts